// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 756 ? "4b178423" : chunkId) + "." + {"241":"3994dde8fa78b6fb","756":"d3912786096fab92"}[chunkId] + ".js";
};